import React, { useState, useEffect, useRef } from 'react';
import './ShippingMethod.css';
import { makeStyles } from '@material-ui/core/styles';
import DatePicker from './DatePicker';
import StorePicker from './StorePicker';
import TimePicker from './TimePicker';
import { setCanContinue, setShippingSelection, setShowError, updateDeliveryDate, setPickupStoreShipping, setExpandedType, setCart, setConfirmSchedule, setConfirmationSuccess, setBooking } from '../../../actions/actionCreators';
import { useSelector, useDispatch } from 'react-redux';
import CartService from '../../../services/CartService';
import DeliveryOptionsService from '../../../services/DeliveryOptionsService';
import ZoneService from '../../../services/ZoneService';
import StoreService from '../../../services/StoreService';
import { useTranslation } from 'react-i18next';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import { isDeliverySelectionValid } from '../../../helper/Utility';
import AddressPicker from './AddressPicker';
import DeliveryInstructionsPicker from './DeliveryInstructionsPicker';
import Place from '@material-ui/icons/PlaceOutlined';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import StoreIcon from '@material-ui/icons/Store';
import NotesIcon from '@material-ui/icons/Notes';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import PhoneIcon from '@material-ui/icons/Phone';
import CustomTextField from '../ShippingAddress/CustomTextField';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import BookingService from '../../../services/BookingService';
import { APP_TYPE, ZENPAY, SCHEDULER } from '../../../constants/AppConstants';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  accordion: {
    boxShadow: 'none',
    paddingBottom: '1rem',
    "&.Mui-expanded:before": {
      opacity: 1,
    },
    "&.Mui-expanded": {
      margin: 0,
      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    },

  }
}));

const alertStyles = makeStyles((theme) => ({
  filledInfo: props => ({
    backgroundColor: `${props.color} !important`,
  }),
}))


const ShippingMethod = ({ source }) => {
  const classes = useStyles();
  const canContinue = useSelector(state => state.navigationReducer.canContinue);
  const urlParams = useSelector(state => state.urlParamsReducer);
  const navigation = useSelector(state => state.navigationReducer);
  const cart = useSelector(state => state.cartReducer);
  const delivery = useSelector(state => state.cartReducer.delivery);
  const frontConfig = useSelector(state => state.frontConfigReducer);
  const coordinates = useSelector(state => { return { lat: state.cartReducer.shipping_address.latitude, lng: state.cartReducer.shipping_address.longitude } });
  const shippingSelection = useSelector(state => state.shippingMethodReducer.selection);
  const [shippingType, setShippingType] = useState(shippingSelection.type);
  const [dateInfo, setDate] = useState(shippingSelection.dateInfo);
  //const [time, setTime] = useState(cart.delivery.time_window_code || shippingSelection?.time);
  const [time, setTime] = useState(shippingSelection?.time);
  const [options, setOptions] = useState(shippingSelection.options);
  const [selectedOption, setSelectedOption] = useState(shippingSelection.selectedOption); // option contains many different days and for each day contains all the dates with time windows
  const [timeWindow, setTimeWindow] = useState(shippingSelection.timeWindow);
  const [day, setDay] = useState(shippingSelection?.day);
  //const [date, setApiDate] = useState(cart.delivery.date || shippingSelection?.date);
  const [date, setApiDate] = useState(shippingSelection?.date);
  const [zone, setZone] = useState(shippingSelection.zone);
  const [todayDateInfo, setTodayDateInfo] = useState({});
  const [storeName, setStoreName] = useState(cart.shipping_address.store?.name);
  const [orderType, setOrderType] = useState('');
  const [deliveryFiltered, setDeliveryFiltered] = useState([]);
  const [pickupFiltered, setPickupFiltered] = useState([]);
  const [selectedOptionTitle, setSelectedOptionTitle] = useState('');
  const [pickupStores, setPickupStores] = useState([]);
  const [selectedPickupStore, setPickupStore] = useState({ id: null });
  const [cartError, setCartError] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [datePickCounter, updateDatePickCounter] = useState(1);
  const [deliveryContact, setDeliveryContact] = useState(null);
  const [openSnack, setOpenSnack] = useState(false);
  const [snackBarMsg, setSnackBarMsg] = useState('Please select a date and time window to confirm your schedule')
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const rootListRef = useRef(null);
  const { t, i18n } = useTranslation();
  // const [geocoder, setGeocoder] = useState(null);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    dispatch(setExpandedType(isExpanded ? panel : "false"));
  };

  const toggleLoading = (loadingState) => {
    if (typeof loadingState === 'boolean') {
      setLoading(loadingState)
    } else {
      setLoading(!loadingState);
    }
  }

  const editContact = (value) => {
    setDeliveryContact(value);
  }

  const handleBlur = async () => {
    let newNote;
    if (cart.note?.map(item => item.includes("Delivery contact")) && cart.note.length > 1) {
      //Get index of delivery contact in notes & replace with new contact
      const removeContact = cart.note.find(note => note.includes("Delivery contact"))
      const notesArray = cart.note.filter(note => note !== removeContact);
      notesArray.push(`Delivery contact: ${deliveryContact}`);
      newNote = notesArray;
    } else {
      newNote = `Delivery contact: ${deliveryContact}`;
    }
    await CartService.updateDelivery({ note: newNote }, cart.token);
  };

  useEffect(() => {
    dispatch(setCanContinue(false))
    const fetchData = async () => {
      setLoading(true);

      try {
        await Promise.all([
          fetchAvailabilities().catch(error => {
            console.error("Error in fetchAvailabilities:", error);
          }),
          fetchAllStores().catch(error => {
            console.error("Error in fetchAllStores:", error);
          }),
        ]);
      } catch (error) {
        console.error("Unexpected error in fetching data:", error);
      } finally {
        setLoading(false); // Ensure loading is stopped even if there's an error
      }
    };

    fetchData();

    checkDeliverySelection()
  }, []);

  useEffect(() => {
    if (APP_TYPE === ZENPAY && date !== null && shippingType !== '' && time !== '') {
      updateCartDelivery();
      dispatch(setCanContinue(true))
    } else if (APP_TYPE === SCHEDULER && navigation.confirmSchedule) {
      if (date !== null && shippingType !== '' && time !== '') {
        updateCartDelivery();
      } else {
        handleClick('Please select a date and time window to confirm your schedule');  // Prompts the user to select a schedule in order to confirm
        dispatch(setConfirmSchedule(false))
      }
    } else {
      dispatch(setCanContinue(false));
    }
    if (date !== null && shippingType !== '' && time !== '' && cartError == false) {
      dispatch(setCanContinue(true))
    } else {
      dispatch(setCanContinue(false));
    }
    updateReduxShippingSelection();
  }, [shippingType, date, time, cartError, navigation.confirmSchedule]) // works now // need to fix this as it's not pushing anything up because of the cart error

  useEffect(() => {
    if (dateInfo.isToday) {
      setTodayDateInfo(dateInfo);
    }
  }, [dateInfo])

  useEffect(() => {
    if (selectedPickupStore.id > 0) {
      fetchPickupStoreAvailabilities()
      setStoreName(selectedPickupStore.name);
    }
  }, [selectedPickupStore.id]);

  useEffect(() => {
    if (APP_TYPE === SCHEDULER && pickupStores.length > 0 && urlParams.pickupOnly) {
      selectPickupType();
    }
  }, [pickupStores])

  const handleClick = (msg) => {
    setOpenSnack(true);
    setSnackBarMsg(msg);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnack(false);
  };
  return (
    <div ref={rootListRef} className={source === 'shopify' ? "SchedulerContainer" : "ShippingMethodContainer"}>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openSnack} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="info">
          {snackBarMsg}
        </Alert>
      </Snackbar>
      {
        loading ? <div className='ShippingLoader'><CircularProgress /></div> : null
      }
      <div className="ShippingTypePickerContainer">
        {urlParams.pickupOnly !== true ?
          <div onClick={selectDeliveryType} style={orderType === 'delivery' ? { borderBottom: `1px solid ${frontConfig.color}` } : deliveryFiltered.length < 1 ? {opacity: 0.25} : null} className={`ShippingBtn`}>
            <LocalShippingIcon style={orderType === 'delivery' ? { fill: frontConfig.color, margin: "0.5rem" } : { fill: '#7A7A7A', margin: "0.5rem" }} />
            <p style={orderType === 'delivery' ? { color: frontConfig.color, margin: "0.5rem" } : { color: 'black', margin: "0.5rem" }} className={`noselect ShippingBtnText`}>{t("Delivery")}</p>
          </div> : null
        }
        <div onClick={selectPickupType} style={orderType === 'pickup' ? { borderBottom: `1px solid ${frontConfig.color}` } : null} className={`ShippingBtn`}>
          <StoreIcon style={orderType === 'pickup' ? { fill: frontConfig.color, margin: "0.5rem" } : { fill: '#7A7A7A', margin: "0.5rem" }} />
          <p style={orderType === 'pickup' ? { color: frontConfig.color } : { color: 'black' }} className={`noselect ShippingBtnText`}>{t("Pickup")}</p>
        </div>
      </div>
      {
        orderType === 'delivery' ?
          <Accordion className={classes.accordion} expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
            <AccordionSummary>
              <Place style={expanded === 'panel5' ? { fill: frontConfig.color, marginTop: '5px' } : { fill: '#7A7A7A', marginTop: '5px' }} />
              {
                expanded === 'panel5' || !cart.shipping_address.address1 ?
                  (<div className='PrefilledAddressContainer'>
                    <p className='DeliveryAddressTitle'>{`${t('Add delivery address')}: `}</p>
                  </div>)
                  :
                  (<div className='PrefilledAddressContainer'>
                    <p className='BoldAddress'>{cart.shipping_address.address1}</p>
                    <p className='AddressText'>{cart.shipping_address.city}, {cart.shipping_address.state_code ? cart.shipping_address.state_code : cart.shipping_address.province_code} {cart.shipping_address.zip}</p>
                  </div>)
              }
            </AccordionSummary>
            <AccordionDetails>
              <div style={{ width: '100%', display: 'flex' }}>
                <AddressPicker onAddressChange={onAddressChange} />
              </div>
            </AccordionDetails>
          </Accordion> : null
      }

      {
        orderType === 'pickup' ?
          <Accordion className={classes.accordion} disabled={orderType !== 'pickup'} expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
            <AccordionSummary>
              <StoreIcon style={expanded === 'panel1' ? { fill: frontConfig.color, marginTop: '5px' } : { fill: '#7A7A7A', marginTop: '5px' }} />
              {
                expanded === 'panel1' ?
                  <div className='PrefilledAddressContainer'>
                    <p className='DeliveryAddressTitle'>{`${t('Choose Store')}: `}</p>
                  </div> :
                  <div className='PrefilledAddressContainer'>
                    <p className='BoldAddress'>{t("Store")}</p>
                    <p className='AddressText'>{storeName !== '' ? storeName : '-'}</p>
                  </div>
              }
            </AccordionSummary>
            <AccordionDetails>
              <div style={{ width: '100%', display: 'flex' }}>
                <StorePicker pickupStores={pickupStores} selectedPickupStore={selectedPickupStore} onStoreSelect={onStoreSelect} resetTime={resetTime} />
              </div>

            </AccordionDetails>
          </Accordion> : null
      }

      {
        orderType === 'delivery' || orderType === 'pickup' ?
          <Accordion className={classes.accordion} expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
            <AccordionSummary>
              <AccessTimeIcon style={expanded === 'panel2' ? { fill: frontConfig.color, marginTop: '5px' } : { fill: '#7A7A7A', marginTop: '5px' }} />
              {
                expanded === 'panel2' ?
                  (<div className='PrefilledAddressContainer'>
                    <p className='DeliveryAddressTitle'>{orderType === 'delivery' ? `${t('Choose Delivery Time')}: ` : `${t('Choose Pickup Time')}: `}</p>
                  </div>)
                  :
                  (<div className='PrefilledAddressContainer'>
                    <p className='BoldAddress'>{orderType === 'delivery' ? `${t('Delivery time')}` : `${t('Pickup time')}`}</p>
                    {
                      dateInfo.monthText !== undefined ?
                      <p className='AddressText'>{(dateInfo.isToday ? ` ${t("TODAY")} ${t(dateInfo.monthText)} ${dateInfo.date} ${dateInfo.year}` : `${t(dateInfo.dayTextFull)} ${t(dateInfo.monthText)} ${dateInfo.date} ${dateInfo.year}`)} {timeWindow && timeWindow.code ? `- ${timeWindow.code}` : null}</p> :
                      <p className='AddressText'>Choose a time window</p>
                    }
                  </div>)
              }
            </AccordionSummary>
            <AccordionDetails>
              <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <div className="DatePickerContainer">
                  <DatePicker selectedOption={orderType === 'delivery' ? deliveryFiltered : pickupFiltered} setDateInfo={setDate} onDateSelect={onDateSelect} defaultDateInfo={dateInfo} defaultDate={date} />
                </div>
                {
                  orderType === 'delivery' ?
                    <div className="TimePickerContainer">
                      {renderDeliveryTimes()}
                    </div> :
                    <div className="StoreTimeParent">
                      {renderPickupTimes()}
                    </div>
                }
              </div>
            </AccordionDetails>
          </Accordion> : null
      }
      {
        orderType === 'delivery' || orderType === 'pickup' ?
          <Accordion className={classes.accordion} expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
            <AccordionSummary>
              <NotesIcon style={expanded === 'panel6' ? { fill: frontConfig.color, marginTop: '5px' } : { fill: '#7A7A7A', marginTop: '5px' }} />
              {
                expanded === 'panel6' || !cart.shipping_address.note ?
                  (<div className='PrefilledAddressContainer'>
                    {
                      orderType === 'delivery' ?
                        <p className='DeliveryAddressTitle'>{`${t('Add delivery instructions')}: `}</p> : orderType === 'pickup' ?
                          <p className='DeliveryAddressTitle'>{t("Add pickup instructions")}</p> : null
                    }
                  </div>)
                  :
                  (<div className='PrefilledAddressContainer'>
                    {
                      orderType === 'delivery' ?
                        <p className='BoldAddress'>{`${t('Delivery Instructions')}`}</p> : orderType === 'pickup' ?
                          <p className='BoldAddress'>{t("Pickup Instructions")}</p> : null
                    }
                    <p className='AddressText'>{cart.shipping_address.note}</p>
                  </div>)
              }
            </AccordionSummary>
            <AccordionDetails>
              <div style={{ width: '100%', display: 'flex' }}>
                <DeliveryInstructionsPicker collapsePicker={handleCollapse} instructions={orderType === 'delivery' ? t("Delivery instructions or delivery contact info") : t("Eg. name and/or phone number of person who will pickup the order")} />
              </div>
            </AccordionDetails>
          </Accordion> : null
      }
      {/* {
        orderType === 'delivery' || orderType == 'pickup' ?
          <Accordion className={accordionClasses.root} expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
            <AccordionSummary>
              <PhoneIcon style={expanded === 'panel7' ? { fill: frontConfig.color, marginTop: '5px' } : { fill: '#7A7A7A', marginTop: '5px' }} />
              {
                expanded === 'panel7' ?
                  <div className='PrefilledAddressContainer'>
                    <p className='DeliveryAddressTitle'>{`${t('Mobile Number')}: `}</p>
                  </div> :
                  <div className='PrefilledAddressContainer'>
                    <p className='BoldAddress'>Mobile Number</p>
                    <p className='AddressText'>{cart.note || deliveryContact || cart.shipping_address.phone}</p>
                  </div>
              }
            </AccordionSummary>
            <AccordionDetails>
              {/* if {cart.shipping_address.phone} && editPhone is false {
              display phone number with edit buton
              
            } 
              <div style={{ width: '100%', display: 'flex' }}>
                <CustomTextField
                  fieldId={"phone"}
                  label="Delivery contact"
                  defaultValue={cart.note || cart.shipping_address.phone}
                  onEditCallBack={editContact}
                  helperTextSecondary="Enter a valid phone number 438 795 2709"
                  onBlur={handleBlur}
                />
              </div>
            </AccordionDetails>
          </Accordion> : null
      } */}

    </div>
  )

  function handleCollapse() {
    handleChange(false);
  }

  function onAddressChange() {
    dispatch(setCanContinue(false))
    fetchAvailabilities();
    fetchAllStores();
  }

  function checkDeliverySelection() {
    if (delivery !== null) {
      let selectionValid = isDeliverySelectionValid(delivery.date);

      if (selectionValid && delivery.option_title.toLowerCase().includes('pick')) {
        setOrderType('pickup');
        setTime(delivery.time_window_code);
        setShippingType(delivery.option_title);
        setSelectedOption(delivery);
      } else if (selectionValid && delivery.option_title.length > 0) {
        setOrderType('delivery');
        setTime(delivery.time_window_code);
        setShippingType(delivery.option_title);
        setSelectedOption(delivery);
      }
    }
  }

  function openTimePicker() {
    // setExpanded('panel3')
  }

  function showNoTimeWindowError() {
    dispatch(setShowError({ showError: true, errorText: 'Sorry no availabilities found. Please try a different date.' }));
  }


  function renderDeliveryTimes() {
    if (deliveryFiltered.length > 0 && dateInfo.noAvailabilities === false) {
      return (
        <TimePicker
          openTimePicker={openTimePicker}
          datePickCounter={datePickCounter}
          selectedTitle={selectedOptionTitle}
          onShippingTypeSelect={onShippingTypeSelect}
          setTitle={setSelectedOptionTitle}
          shippingType={shippingType}
          selectedOption={deliveryFiltered}
          time={time}
          onTimeSelect={onTimeSelect}
          day={day}
          date={date}
          resetTime={resetTime}
          showNoTimeWindowError={showNoTimeWindowError}
          dateInfo={dateInfo} />
      )
    } else {
      return null
    }
  }

  function renderPickupTimes() {
    if (dateInfo.noAvailabilities === false) {
      return pickupFiltered.map((option, i) => {
        return (
          <TimePicker
            openTimePicker={openTimePicker}
            datePickCounter={datePickCounter}
            selectedTitle={selectedOptionTitle}
            onShippingTypeSelect={onShippingTypeSelect}
            setTitle={setSelectedOptionTitle}
            key={i}
            shippingType={shippingType}
            selectedOption={[option]}
            time={time}
            onTimeSelect={onTimeSelect}
            day={day}
            date={date}
            resetTime={resetTime}
            showNoTimeWindowError={showNoTimeWindowError}
            dateInfo={dateInfo} />
        )
      })
    } else {
      return null;
    }
  }

  function onStoreSelect(store) {
    dispatch(setPickupStoreShipping({ ...store }));
    setPickupStore({ ...store })
  }

  function selectDeliveryType() {
    if (deliveryFiltered.length > 0) {
      setOrderType('delivery');
      setExpanded('panel2');
      dispatch(setExpandedType("panel2"));
    } else {
      // handleClick("Sorry no delivery options found, you can still select a pickup location")
      // dispatch(setShowError({ showError: true, errorText: t('Sorry no delivery options found, you can still select a pickup location') }));
    }
  }

  function selectPickupType() {
    setOrderType('pickup');
    setExpanded('panel1');
    dispatch(setExpandedType("panel1"));
  }

  function onShippingTypeSelect(type, option) {
    setShippingType(type);
    setSelectedOption(option);
  }

  function onDateSelect(dateInfo) {
    var newValue = datePickCounter;
    newValue += 1;
    updateDatePickCounter(newValue);
    setDate(dateInfo);
    setDay(dateInfo.dayTextFull);
    setApiDate(dateInfo.apiDate);
    setSelectedOptionTitle('');
    resetTime();
  }

  function onTimeSelect(timeWindow) {
    setTime(timeWindow.code);
    let timeWindowCopy = { ...timeWindow };
    delete timeWindowCopy.scheduleOption;
    delete timeWindowCopy.id;
    setTimeWindow(timeWindow);
    setExpanded('panel6');
    dispatch(setExpandedType("panel6"));
  }

  function resetTime() {
    setTime('');
  }

  async function fetchAllStores() {
    var storesResponse = await StoreService.getAllStores(cart.token);
    if (APP_TYPE === ZENPAY && Array.isArray(storesResponse) && storesResponse.length > 0) {
      const filteredResponse = storesResponse.filter(store => store.available_pickup_slots > 0);
      setPickupStores(filteredResponse);
    }
    if (APP_TYPE === SCHEDULER && Array.isArray(storesResponse) && storesResponse.length > 0) {
      //new check for location id and if location id is provided and is a valid one then preselects store and filters out other stores
      // if provided store id is not valid then allow user to manually select the store for now
      const filteredResponse = storesResponse.filter(store => store.available_pickup_slots > 0);
      if (urlParams.location_id !== undefined && urlParams.location_id !== null) {
        let filteredByStore = storesResponse.filter((currentStore) => currentStore.id === parseInt(urlParams.location_id));
        if (filteredByStore[0]) {
          onStoreSelect(filteredByStore[0]);
          setPickupStores(filteredByStore);
        } else {
          handleClick('Sorry we could not find your store');
          setPickupStores(filteredResponse)
        }
      } else {
        setPickupStores(filteredResponse);
      }
    }
  }

  async function fetchPickupStoreAvailabilities() {
    const availabilitiesResponse = await DeliveryOptionsService.getPickupOptions(cart.token, selectedPickupStore.id);
    if (Array.isArray(availabilitiesResponse)) {
      setPickupFiltered(availabilitiesResponse);
      if (availabilitiesResponse.length > 0) {
        setExpanded('panel2');
        dispatch(setExpandedType("panel2"));
      } else {
        dispatch(setShowError({ showError: true, errorText: 'Sorry no availabilities found. please select a different store.' }));
      }
    }
  }

  async function fetchAvailabilities() {
    //const availabilitiesResponse = await ZoneService.getZoneByLocation(cor, cart.token);
    const availabilitiesResponse = await ZoneService.getZoneByLocation(coordinates, cart.token);
    if (Array.isArray(availabilitiesResponse.delivery_options) && availabilitiesResponse.delivery_options.length > 0) {
      setOptions(availabilitiesResponse.delivery_options);
      setZone(availabilitiesResponse);
      setStoreName(availabilitiesResponse.store.name);
      let deliveryOnly = availabilitiesResponse.delivery_options.filter((option) => option.title.toLowerCase().includes('pick') == false);
      var pickupOnly = availabilitiesResponse.delivery_options.filter((option) => option.title.toLowerCase().includes('pick'));
      setDeliveryFiltered(deliveryOnly);
    } else if (Array.isArray(availabilitiesResponse.delivery_options)) {
      dispatch(setShowError({ showError: true, errorText: t('Sorry no delivery options found, you can still select a pickup location') }));
    }
  }

  async function updateCartDelivery() {
    let report = {
      date: date,
      option_code: selectedOption.code ? selectedOption.code : selectedOption.option_code ? selectedOption.option_code : undefined,
      day_code: day.toLowerCase(),
      time_window_code: time,
      note: cart.shipping_address.note,
    }

    if (APP_TYPE === SCHEDULER && urlParams.source === 'cigo') {
      report.source = 'cigo';
      report.remote_id = urlParams.id;
      dispatch(setBooking(report));
      const bookingResponse = await BookingService.createBooking(report, urlParams.token);
      setTimeout(() => {
        dispatch(setConfirmationSuccess(true))
      }, 2000);
    } else if (APP_TYPE === SCHEDULER && urlParams.source === 'shopify') {
      const cartAttributeReport = {
        attributes: {
          user: selectedOption.code ? selectedOption.code : selectedOption.option_code ? selectedOption.option_code : undefined,
          DeliveryTitle: day.toLowerCase(),
          DeliveryDate: date,
          Time: time,
          Store: 1,
        }
      }
      const updateCartAttributeResponse = await CartService.updateShopifyCartAttribute(cartAttributeReport);
    }
    const updateDeliveryResponse = await CartService.updateDelivery({ delivery: report }, cart.token);

    if (updateDeliveryResponse.error) {
      dispatch(setShowError({ showError: true, errorText: updateDeliveryResponse.error.message ? updateDeliveryResponse.error.message : 'Sorry we are experiencing issues with the checkout, Please try again later' }));
      setCartError(true);
    } else if (updateDeliveryResponse.date) {
      dispatch(updateDeliveryDate(updateDeliveryResponse));
      setCartError(false);

      const newCartResponse = await CartService.cartData(cart.token);
      if (newCartResponse.customer) {
        dispatch(setCart(newCartResponse));
      }
    }
  }

  function updateReduxShippingSelection() {
    let payload = [
      { fieldToUpdate: 'date', value: date },
      { fieldToUpdate: 'zone', value: zone },
      { fieldToUpdate: 'day', value: day },
      { fieldToUpdate: 'dateInfo', value: dateInfo },
      { fieldToUpdate: 'type', value: shippingType },
      { fieldToUpdate: 'options', value: options },
      { fieldToUpdate: 'selectedOption', value: selectedOption },
      { fieldToUpdate: 'time', value: time },
      { fieldToUpdate: 'timeWindow', value: timeWindow },
      { fieldToUpdate: 'todayDateInfo', value: todayDateInfo },
    ]
    dispatch(setShippingSelection(payload))
  }
}

function Alert(props) {
  const frontConfig = useSelector(state => state.frontConfigReducer);
  const alertClasses = alertStyles({ color: frontConfig.color });

  return <MuiAlert className={alertClasses.filledInfo} elevation={6} variant="filled" {...props} />;
}
export default ShippingMethod;